export const TAB_LIST_WIDTH = 190;
export const SEARCH_TERM_PARAM_KEY = 'searchTerm';
export const OBJECT_TYPE_PAGES = 'Page';
export const FOCUSABLE_ELEMENT_CLASS = 'search-focusable';
